//Prefixo para o endpoint /select_/objeto
import { useEffect, useState } from "react";
import api from "../services/api";
import Mensagens from "../utils/MensagemUtils";

export function useDropdownHooks(endpoint, filtros = {}) {
    const {
        habilitado = true,
        transformar = (data) => data.map(item => ({
            value: item.id?.toString(),
            label: item.nome || item.descricao || item.valor || item.razaoSocial || item.unidade,
        })),
        retornarObjetoCompleto = false // NOVA PROP
    } = filtros;

    const [filtrosSelecionados, setFiltrosSelecionados] = useState([]);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        if (!habilitado || !endpoint) return;

        const fetchData = async () => {
            setCarregando(true);
            setErro(null);

            try {
                const apiResponse = await api.get("/select_/" + endpoint);

                if (apiResponse.success) {
                    const dados = apiResponse.data;
                    const itens = Array.isArray(dados) ? dados : (dados.content || []);
                    const dadosTransformados = retornarObjetoCompleto ? itens : transformar(itens);
                    setFiltrosSelecionados(dadosTransformados);
                } else {
                    setErro(apiResponse.message || Mensagens.ERRO.ERRO_BUSCAR_DADOS);
                }

            } catch (error) {
                setErro(error.message);
                setFiltrosSelecionados([]);
            } finally {
                setCarregando(false);
            }
        };

        fetchData();
    }, [endpoint, habilitado, retornarObjetoCompleto]);

    return { itens: filtrosSelecionados, carregando, erro };
}

export function useGrupoPermissao() {
    return useDropdownHooks("grupoPermissao");
}

export function useTipoSistema() {
    return useDropdownHooks("tipoSistema");
}

export function useEmpresa() {
    return useDropdownHooks("empresa");
}

export function useCliente() {
    return useDropdownHooks("cliente");
}

export function useUnidade(id) {
    const endpoint = id ? `sistema/${id}` : '';
    return useDropdownHooks(endpoint);
}


export function usePlano(retornarObjetoCompleto = true) {
    return useDropdownHooks('plano', { retornarObjetoCompleto });
}

export function useEntidades() {
    const options = [
        { value: 'USUARIO', label: 'Usuário' },
        { value: 'EMPRESA', label: 'Empresa' },
        { value: 'CLIENTE ', label: 'Cliente' },
        { value: 'SISTEMA ', label: 'Sistema' }
    ];
    return { options, isLoading: false, error: null };
}
